import {useEffect} from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
import {hideScroll} from 'src/theme/css';
import {usePathname} from 'src/routes/hooks';

import {useResponsive} from 'src/hooks/use-responsive';
import {useMockedUser} from 'src/hooks/use-mocked-user';

import Logo from 'src/minimal-components/logo';
import {NavSectionVertical} from 'src/minimal-components/nav-section';

import {NAV} from '../config-layout';

import NavToggleButton from '../common/nav-toggle-button';
import {CircularProgress} from '@mui/material';

type ModulesMenuListComponentProps = {
  navData: any;
  openNav?: any;
  isOpenNav: boolean;
  onCloseNav: VoidFunction;
  isLoading?: boolean;
  module?: string;
  menuItem?: any;
  renderCountBadge?: (countItem: any) => JSX.Element;
  menuListData?: any;
  filtersData?: any;
  setExternalUrl?: any;
  setVisitDetails?: any;
  applicationName?: string;
};

export default function NavVertical(props: ModulesMenuListComponentProps) {
  const {user} = useMockedUser();
  const pathname = usePathname();
  const lgUp = useResponsive('up', 'lg');
  const {
    navData,
    isOpenNav,
    onCloseNav,
    isLoading,
    module,
    menuItem,
    renderCountBadge,
    menuListData,
    filtersData,
    setExternalUrl,
    setVisitDetails,
    applicationName
  } = props;
  useEffect(() => {
    if (isOpenNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Stack
      sx={{
        flex: 1,
        backgroundColor: theme => theme.palette.primary.darker,
        overflowY: 'auto',
        overflowX: 'hidden',
        '::-webkit-scrollbar': {
          width: '10px'
        },
        '::-webkit-scrollbar-track': {
          backgroundColor: 'transparent'
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor: theme => theme.palette.grey[500],
          borderRadius: '999px'
        },
      }}>
      <Logo applicationName={applicationName} sx={{mt: 3, ml: 4, mb: 1}} />

      {isLoading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}>
          <CircularProgress />
        </Box>
      ) : (
        <NavSectionVertical
          data={navData}
          slotProps={{
            currentRole: user?.role
          }}
          module={module}
          menuItem={menuItem}
          renderCountBadge={renderCountBadge}
          menuListData={menuListData}
          filtersData={filtersData}
          setExternalUrl={setExternalUrl}
          setVisitDetails={setVisitDetails}
        />
      )}
    </Stack>
  );

  return (
    <Box
      sx={{
        flexShrink: {lg: 0},
        width: {lg: NAV.W_VERTICAL}
      }}>
      <NavToggleButton />

      {lgUp ? (
        <Stack
          sx={{
            pb: 2,
            height: 1,
            position: 'fixed',
            width: NAV.W_VERTICAL,
            backgroundColor: theme => theme.palette.primary.darker,
            borderRight: theme => `dashed 1px ${theme.palette.divider}`,
            ...hideScroll.x
          }}>
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={isOpenNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.W_VERTICAL
            }
          }}>
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
